module.exports = __webpack_public_path__ + "static/media/cathy.055fb49d.jpg";